/**
 *
 * @param arr array of objects e.g. [{rating: 'high', score: 3}, {rating: 'low', score: '0'}]
 * @param sortingKey sorting key is a valid key inside the array of objects passed above e.g. score or rating would be
 * the valid sorting keys in this case
 * @returns
 */
export const getHighestValueFromArray = (arr: any, sortingKey: string) => {
  try {
    // check for validity of the params
    if (!arr || !Array.isArray(arr) || !arr.length || !sortingKey) {
      console.warn(
        `Error: Invalid parameters passed to getHighestValueFromArray method ${arr} ${sortingKey}`,
      );
      return;
    }
    // check for the validity of the sorting key
    if (!Object.hasOwn(arr[0], sortingKey)) {
      console.warn(`Error: Sorting key ${sortingKey} is not present in the Array passed`);
      return;
    }
    // return the item with the highest of the value from inside the array
    return arr.reduce(function (prev: any, current: any) {
      return prev &&
        typeof prev === 'object' &&
        typeof current === 'object' &&
        prev[sortingKey] > current[sortingKey]
        ? prev
        : current;
    });
  } catch (error: any) {
    console.error(error && error.message);
  }
};
